<div class="login_page">
  <div class="lg_main">
    <div class="lg_right eq_H" [ngStyle]="{ height: innerHeight }">
      <img src="https://purchasepointe.spark-staging.dev/assets/images/loginpage.jpg" />
    </div>
    <div class="lg_left eq_H" [ngStyle]="{ height: innerHeight }">
      <div class="lg_left_inner">
        <div class="full_width text-center">
          <div class="logoodsas">
            <div class="logoodsas_inner">
              <img src="https://purchasepointe.spark-staging.dev/uploads/site_logo/1581523657_aelogo.png" />
            </div>
          </div>
        </div>
        <div class="form_main loginHJL">
          <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit(resetPasswordForm)">
            <div class="lg_form_inner">
              <div id="error-display"></div>
              <div class="form-group">
                <label>New Password</label>
                <input
                  type="password"
                  name="password"
                  placeholder="Enter New Password"
                  class="form-control"
                  value=""
                  formControlName="password" />
                <span
                  class="error"
                  *ngIf="
                    resetPasswordForm.get('password').hasError('required') && resetPasswordForm.get('password').touched
                  ">
                  Please Provide A Password.
                </span>
              </div>
              <div class="form-group">
                <label>Confirm Password</label>
                <input
                  type="password"
                  name="confirm_password"
                  placeholder="Enter Confirm Password"
                  class="form-control"
                  value=""
                  formControlName="confirm_password" />
                <span
                  class="error"
                  *ngIf="
                    resetPasswordForm.get('confirm_password').hasError('required') &&
                    resetPasswordForm.get('confirm_password').touched
                  ">
                  Please Provide Confirm Password.
                </span>
                <span
                  class="error"
                  *ngIf="
                    resetPasswordForm.get('confirm_password').hasError('confirmedValidator') &&
                    resetPasswordForm.get('confirm_password').touched
                  ">
                  Please Provide Valid Confirm Password.
                </span>
              </div>
              <div class="form-group mrg50 mrzerox btmzeroxz text-left">
                <button type="submit" class="lg_btn_coolsx mr5sx full_width">Reset</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
